export default function getNormalizedEnv(env: string): string {
  switch (env) {
    case 'dev':
      return 'dev';
    case 'local':
    case 'ci':
    case 'qa':
      return 'qa';
    case 'sbx':
      return 'sbx';
    default:
      return 'prd';
  }
}
